/* istanbul ignore file */
import { useToken } from '@ori/auth';
import { useGetCustomerSponsorPersonalBeautyStore } from '@ori/global-api-client-react';

const useSponsorPersonalBeautyStoreInfo = () => {
  const { isAnonymousUser, customerId } = useToken();
  const result = useGetCustomerSponsorPersonalBeautyStore<Error>(customerId, undefined, {
    swr: {
      enabled: !isAnonymousUser,
    },
  });

  return result;
};

export default useSponsorPersonalBeautyStoreInfo;
